module.exports = __webpack_public_path__ + "866757d4fc54c0e2957442a905b9ee35.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/head/RamonaRamon_in_Athen.jpg
// module id = 763
// module chunks = 0